import * as React from "react";

const ReportNamePopover = (
  <div className="report-name-popover">
    <p>
      <strong>Report Name:</strong> This is the name used to identify the report
      definition which includes delivery <br />
      schedule, file content and other information.
    </p>
  </div>
);

export default ReportNamePopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportFormat/ReportNamePopover.tsx